import { useState } from "react";
import { SharingTargetType } from "@newComponents/common/dialogs/SharingSettingsDialog";
import { BrowseEntrySummary, BrowseEntryType } from "@maven-rest/docs/Folder.dto";

export function useArchiverHandlers(dialogs: {
  openSharingDialog: { onTrue: () => void };
  openRenameResourceDialog: { onTrue: () => void };
  openRemoveFolderDialog: { onTrue: () => void };
  openRemoveFileDialog: { onTrue: () => void };
  openMoveResourceDialog: { onTrue: () => void };
}) {
  const [sharingTarget, setSharingTarget] = useState<SharingTargetType>({
    folderId: BigInt(0),
    fileName: "",
    browseEntrySummary: undefined,
  });
  const [renameResourceTarget, setRenameResourceTarget] = useState<{ resourceId: bigint; name: string; type: BrowseEntryType }>();
  const [removeFolderTarget, setRemoveFolderTarget] = useState<{ folderId: bigint; name: string }>();
  const [removeFileTarget, setRemoveFileTarget] = useState<{ fileId: bigint; name: string }>();
  const [moveResourceTarget, setMoveResourceTarget] = useState<BrowseEntrySummary>();

  return {
    clickedRow: { sharingTarget, renameResourceTarget, removeFolderTarget, removeFileTarget, moveResourceTarget },
    clickHandler: {
      handleSharingSettingsClick: (entry: BrowseEntrySummary) => {
        dialogs.openSharingDialog.onTrue();
        setSharingTarget({
          folderId: entry.type === BrowseEntryType.Folder ? entry.resource.id : entry.resource.folderId,
          fileId: entry.type === BrowseEntryType.Folder ? undefined : entry.resource.id,
          fileName: entry.resource.name,
          browseEntrySummary: entry,
        });
      },
      handleRenameClick: (entry: BrowseEntrySummary) => {
        dialogs.openRenameResourceDialog.onTrue();
        setRenameResourceTarget({ resourceId: entry.resource.id, name: entry.resource.name, type: entry.type });
      },
      handleDeleteFolderClick: (entry: BrowseEntrySummary) => {
        dialogs.openRemoveFolderDialog.onTrue();
        setRemoveFolderTarget({ folderId: entry.resource.id, name: entry.resource.name });
      },
      handleDeleteFileClick: (entry: BrowseEntrySummary) => {
        dialogs.openRemoveFileDialog.onTrue();
        setRemoveFileTarget({ fileId: entry.resource.id, name: entry.resource.name });
      },
      handleMoveToClick: (entry: BrowseEntrySummary) => {
        dialogs.openMoveResourceDialog.onTrue();
        setMoveResourceTarget(entry);
      },
    },
  };
}
